// removed by extract-text-webpack-plugin
module.exports = {"headline":"XxLJKt82hgWqEZjBe5tTZ","headlineWarn":"_2mZZlqhz-W7WGaW__fdfSH","headlineStop":"_3h3-HhcsChojioS-jRxI0p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultsContainer/Headline/styles.css
// module id = 402
// module chunks = 0